<template>
    <div>
        <v-container max-width="2500" style="max-width: 3000px !important">
            <v-card class="mx-auto my-5" max-width="2500">
                <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
                    Formulario registro paciente</v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" max-width="2100">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchNombre" label="Nombre"
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            @input="dataInit"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field max-width="200" class="mx-3" v-model="searchDocumento" label="Número Doc."
                            prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line
                            @input="dataInit"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="5" md="5" class="mx-3">
                        <v-btn color="#1973a5" dark class="mb-2" @click="createOpen" style="margin-top: 1rem">
                            Nuevo
                        </v-btn>
                        <v-btn color="#1973a5" dark class="mb-2" @click="cargaMasivaOpen" style="margin: 1rem">
                            Carga
                        </v-btn>
                        <v-btn color="#1973a5" dark class="mb-2" @click="downloadExcel" style="margin: 1rem">
                            Formato
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" max-width="2500">
                <div style="max-height: 70vh; overflow-y: scroll">
                    <v-data-table :headers="headers" :items="filteredData" class="elevation-1" :sort-by.sync="sortBy"
                        :loading="isLoading" loading-text="Cargando... Por favor espere">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small class="mr-3" @click="editOpen(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small class="mr-3" @click="deleteOpen(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </div>
                <!-- <v-dialog v-model="dialogEdit" v-if="dialogEdit" max-width="1000px">
            <formPaciente @editClose="editClose" :idItem="idItem" @openAsigCupo="openAsigCupo"></formPaciente>
          </v-dialog> -->
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="text-h5">¿Esta seguro de eliminar registro?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="deleteClose">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItem">OK</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!-- <v-dialog v-model="dialogCargaMasiva" v-if="dialogCargaMasiva" max-width="500px">
            <CargaMasivaPaciente @closeDialog="cargaMasivaClose" />
          </v-dialog>
          <v-dialog v-if="dialogAsignarCupo" v-model="dialogAsignarCupo" max-width="600px" persistent>
            <AsignarCupo @closeDialogAsignarCupo="closeDialogAsignarCupo" :pacienteRegistrado="pacienteRegistrado" />
          </v-dialog> -->
            </v-card>
            <v-dialog v-model="dialogLoader" hide-overlay persistent width="300" class="fondo-griss">
                <v-card color="primary" dark>
                    <v-card-text>
                        Cargando Datos
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<style>
.bg-primary-table {
    /* background: rgb(27 160 255 / 12%); */
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    data() {
        return {
            dialogLoader: false,
            polygonOptions: {
                strokeColor: '#FF0000', // Color del borde
                strokeOpacity: 0.1,     // Opacidad del borde
                strokeWeight: 0.1,        // Grosor del borde
                fillColor: '#FF0000',   // Color de relleno
                fillOpacity: 0.35       // Opacidad de relleno
            },
            marcadores: [
                {
                    posicion: { lat: -12.074928851253814, lng: -77.04316187097396 },
                    nombre_completo: 'Ubique al \\n paciente'
                },
            ],
            e1: 1,
            step: 1,
            itemsUbigeo: [],
            itemsDepartamento: [],
            itemsDistrito: [],
            itemsProvincia: [],
            dataHospital: [],
            dataMedico: [],
            dialogAsignarCupo: false,
            dialogCargaMasiva: false,
            valor1: 15,
            valor2: 10,
            ver: false,
            searchDocumento: "",
            searchNombre: "",
            dataPaciente: [],
            dataEnvio: {
                fecha: null,
            },
            titleButton: "",
            titleCard: "",
            valid: true,
            pacienteData: {
                tipo_doc: null,
                num_doc: null,
                nombres: null,
                ape_pat: null,
                ape_mat: null,
                fecha_nac: null,
                cas: null,
                estado: 1,
                sexo: null,
                cordePacForm: null,
                latitud: null,
                longitud: null,
                direccion: null,
                distrito: null,
                user_id: null,
                cordePac: null,
                telefono: null,
                telefonoAlterno: null,
                departamento: null,
                provincia: null,
                ubigeo_id: null,
                medico_id: null,
                hospital_id: null,
                fecha_ultima_dialisis: null,
                serologia: null,
                pacienteId: null
            },
            cas: null,
            maestro: null,
            deleteUser: [],
            statusEdit: false,
            date: new Date()
                .toISOString()
                .substr(0, 10),
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Nombre", value: "nombres" },
                { text: "Ape. Paterno", value: "ape_pat" },
                { text: "Ape. Materno", value: "ape_mat" },
                { text: "Fec. Nac.", value: "fecha_nac" },
                { text: "Clínica", value: "descripCas" },
                { text: "Sexo", value: "genero" },
                { text: "Tipo Doc", value: "descripMaestro" },
                { text: "Num. Doc", value: "num_doc" },
                { text: "Hospital", value: "hospital" },
                { text: "Medico", value: "medico" },
                { text: "Serología", value: "serologia" },
                { text: "Distrito", value: "distritoDescrip" },
                { text: "Actions", align: "center", value: "actions", sortable: false },
            ],
            dialogEdit: false,
            dialogDelete: false,
            dataCas: [],
            dataMaesto: [],
            isLoading: false,
            itemsTipSex: ["MASCULINO", "FEMENINO"],
            menu: false,
            menu1: false,
            date: new Date().toISOString().substr(0, 10),
            itemsPacientes: [],
            arraySerologia: [{ value: "positivo", label: "Positivo" }, { value: "negativo", label: "Negativo" }],
            pacienteRegistrado: [],
            idItem: null
        };

    },
    methods: {
        openAsigCupo(item) {
            console.log("esta golpeando 1234");
            this.pacienteRegistrado = item;
            this.dialogAsignarCupo = true;
        },
        loadPacienteGPS() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/paciente/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.itemsPacientes = res.data;
                        })
                        .catch((res) => {
                            console.warn("Error:", res);
                            this.dialog = false;

                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        onMarkerDragEnd(index, event) {
            // Obtiene las nuevas coordenadas del marcador
            const newLat = event.latLng.lat();
            const newLng = event.latLng.lng();

            // Actualiza las coordenadas del marcador en la lista
            this.marcadores[index].posicion = { lat: newLat, lng: newLng };
            this.pacienteData.cordePacForm = `${newLat}, ${newLng}`;
            // Realiza cualquier otra acción necesaria con las nuevas coordenadas
            console.log('Nuevas coordenadas:', newLat, newLng);
        },
        loadProvinciaEdit() {
            const provincia = this.itemsUbigeo.filter(item =>
                item.url == this.pacienteData.distrito
            );
            this.pacienteData.departamento = provincia[0].departamento;
            this.loadProvincia();
            this.pacienteData.provincia = provincia[0].provincia;
            this.loadDistrito();
            this.pacienteData.distrito = provincia[0].url;

        },
        loadDepartamentos() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/ubigeo/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.itemsUbigeo = res.data;
                            this.itemsDepartamento = res.data.filter((value, index, self) =>
                                index === self.findIndex((t) => (
                                    t.departamento === value.departamento
                                ))
                            );
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadProvincia() {
            this.pacienteData.distrito = "";
            this.itemsDistrito = [];
            this.itemsProvincia = this.itemsUbigeo.filter(item =>
                item.departamento == this.pacienteData.departamento
            );
        },
        loadDistrito() {
            this.itemsDistrito = this.itemsUbigeo.filter(item =>
                item.provincia == this.pacienteData.provincia
            );
        },
        closeDialogAsignarCupo() {
            this.dialogAsignarCupo = false;
        },
        downloadExcel() {
            const XLSXStyle = require("xlsx-js-style");

            // STEP 1: Create a new workbook
            const wb = XLSXStyle.utils.book_new();

            // STEP 2: Create data rows and styles
            const headers = [
                { text: "tipo_doc", cell: "A1", style: true },
                { text: "num_doc", cell: "B1", style: true },
                { text: "ape_pat", cell: "C1", style: true },
                { text: "ape_mat", cell: "D1", style: true },
                { text: "nombres", cell: "E1", style: true },
                { text: "fecha_nac", cell: "F1", style: true },
                { text: "sexo", cell: "G1", style: true },
                { text: "cas_id", cell: "H1", style: true },
                { text: "cordepac", cell: "I1", style: true },
                { text: "direccion", cell: "J1", style: true },
                { text: "distrito", cell: "K1", style: true }
            ];
            // STEP 3: Create worksheet with rows; Add worksheet to workbook
            const ws = XLSXStyle.utils.aoa_to_sheet([]);
            for (let i = 0; i < headers.length; i++) {
                const element = headers[i];
                XLSXStyle.utils.sheet_add_aoa(ws, [[element.text]], {
                    origin: element.cell,
                });
                ws[element.cell].s = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
                        bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
                        left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
                        right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
                    },
                    alignment: { wrapText: true },
                };
                if (element.style) {
                    ws[element.cell].s = {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } }, // Bordes superior
                            bottom: { style: "thin", color: { rgb: "000000" } }, // Bordes inferior
                            left: { style: "thin", color: { rgb: "000000" } }, // Bordes izquierdo
                            right: { style: "thin", color: { rgb: "000000" } }, // Bordes derecho
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center",
                            wrapText: true,
                        },
                    };
                }
            }



            XLSXStyle.utils.book_append_sheet(wb, ws, "readme demo");

            // STEP 4: Write Excel file to browser
            const excelBuffer = XLSXStyle.write(wb, {
                bookType: "xlsx",
                type: "array",
            });
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Formato_registro_paciente.xlsx";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        },
        cargaMasivaOpen() {
            this.dialogCargaMasiva = true;
        },
        cargaMasivaClose() {
            this.dialogCargaMasiva = false;
            this.dataInit();
        },
        filtro() {
            this.dataEnvio.fecha = this.date;
            this.dataEnvio.fecha = this.formatearFecha(this.date);
            this.dataInit();
        },
        createOpen() {
            this.idItem = null;
            this.dialogEdit = true;
        },
        editOpen(item) {
            this.idItem = item;
            this.statusEdit = true;
            this.dialogEdit = true;
        },
        editClose() {
            this.dialogEdit = false;
            this.idItem = null;
            this.dataInit();
        },
        deleteOpen(item) {
            this.deleteUser = item;
            this.dialogDelete = true;
        },
        deleteClose() {
            this.dialogDelete = false;
        },
        deleteItem() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .delete(
                            RUTA_API + "/paciente/" + this.deleteUser.url.split("/")[4] + "/",
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            this.dialogDelete = false;
                            this.dataInit();
                            this.dialogEdit = false;
                        })
                        .catch((res) => {
                            console.warn("Error:", res);
                            this.dialogDelete = false;
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
            /*} else {
              this.dialogEdit = false;
              this.dialogAvisoEditar = true;
            }*/
        },
        dataInit() {
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/pacienteIndex/?num_doc=" + this.searchDocumento + "&nombre=" + this.searchNombre, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            this.dataPaciente = res.data;
                            this.dataPaciente.forEach((item) => {
                                // Calcula el nombre completo y guárdalo en una nueva propiedad 'nombreCompleto'
                                item.descripCas = item.datosCasOri ? `${item.datosCasOri.descripCas}` : ``;
                                item.descripMaestro = `${item.datosMaestro.descripMaestro}`;
                                item.medico = `${item.datosMedico ? item.datosMedico.nombre : ""}`;
                                item.hospital = `${item.datosHospital ? item.datosHospital.hospital : ""}`;
                                item.distritoDescrip = `${item.datosUbigeo ? item.datosUbigeo.distrito : ""}`;
                                item.genero = `${item.sexo == "F" || item.sexo == "FEMENINO" ? "F" : "M"}`;
                            });
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadCas() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/cas/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataCas = res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
        },
        loadHospital() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/hospital/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataHospital = res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadMaestro() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/maestro/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataMaesto = res.data;
                            this.dataMaesto = res.data.filter(
                                (e) =>
                                    e.codMaestro == "ND001"
                            );
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        formatearFecha(fecha) {
            // Dividir la fecha en partes: año, mes y día
            const partes = fecha.split("-");
            // Crear una nueva fecha con el formato "mm-dd-yyyy"
            const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
            // Obtener el mes, día y año de la nueva fecha
            const mes = nuevaFecha.getMonth() + 1;
            const dia = nuevaFecha.getDate();
            const año = nuevaFecha.getFullYear();
            // Formatear la fecha en el formato deseado
            return `${mes.toString().padStart(2, "0")}-${dia
                .toString()
                .padStart(2, "0")}-${año}`;
        },
        clearForm() {
            this.pacienteData = {
                tipo_doc: null,
                num_doc: null,
                nombres: null,
                ape_pat: null,
                ape_mat: null,
                fecha_nac: null,
                cas: null,
                estado: 1,
                sexo: null,
                cordePac: null,
                latitud: null,
                longitud: null,
                direccion: null,
                distrito: null,
                user_id: null,
                telefonoAlterno: null,
                telefono: null,
                ubigeo_id: null,
                medico_id: null,
                hospital_id: null,
                serologia: null
            };
            this.date = null;
            this.cas = null;
            this.maestro = null;
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    mounted() { },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        computedDateFormatted1() {
            return this.formatDate(this.date1);
        },
        dataCasOptions() {
            // Formatear los elementos del objeto según lo requerido por v-select
            return this.dataCas.map((item) => ({
                text: item.descripCas,
                value: item.url,
            }));
        },
        itemClass() {
            return (item) => {
                if (item.cupos_disponible === 0) {
                    return ""; // Aplica la clase "bg-primary" para el color #007bff
                } else {
                    return "bg-primary-table primary--text"; // No se aplica ninguna clase
                }
            };
        },
        filteredData() {
            if (!this.searchNombre && !this.searchDocumento) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchNombre) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = `${item.nombres} ${item.ape_pat} ${item.ape_mat}`;
                    return nombreCompleto.toLowerCase().includes(this.searchNombre.toLowerCase());
                });
            }
            if (this.searchDocumento) {
                filtered = filtered.filter((item) =>
                    item.num_doc
                        .toLowerCase()
                        .includes(this.searchDocumento.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
        this.loadCas();
        this.loadMaestro();
        this.dataInit();
        this.loadDepartamentos();
        this.loadHospital();
        this.loadMedico();
        this.loadPacienteGPS();
    },
    components: {
    },
};
</script>